<p-confirmdialog />
<p-toast />

<div class="container px-4 py-10">
  <block-ui>
    <div class="w-full p-2 m-2">
      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="mb-7">
          <h1 class="mb-1 text-2xl font-semibold text-primary-200">
            Subscriptions
          </h1>
          <p class="text-sm text-primary-500">View all of Your Subscriptions</p>
        </div>
        <div class="flex gap-2">
          <p-button
            icon="pi pi-download"
            label="Export"
            severity="secondary"></p-button>
          <p-button
            icon="pi pi-plus"
            label="Add New"
            severity="primary"
            (onClick)="addSubscription()"></p-button>
        </div>
      </div>

      <!-- Tabs -->
      <p-tabMenu
        [model]="tabs"
        [activeItem]="activeTab"
        class="mt-4 border-b"></p-tabMenu>
    </div>
    <div class="w-full p-2 m-2">
      <p-table
        #dt2
        dataKey="id"
        stripedRows
        [value]="filtered_subscriptions"
        responsiveLayout="scroll"
        [paginator]="true"
        [scrollable]="true"
        [resizableColumns]="true"
        [autoLayout]="true"
        [globalFilterFields]="[
          'customer_id.name',
          'plan.name',
          'is_active',
          'status',
          'next_due',
          'months_to_bill',
          'amount',
          'actual_amount',
          'asset_id.length'
        ]"
        [rows]="25"
        selectionMode="single"
        (onRowSelect)="rowSelected()"
        [(selection)]="selectedSubscription"
        [tableStyle]="{ 'min-width': '50rem' }"
        [rowsPerPageOptions]="[25, 50, 100]">
        <ng-template #emptymessage>
          <tr>
            <td colspan="8">No subscriptions found.</td>
          </tr>
        </ng-template>
        <ng-template #caption>
          <div class="flex">
            <p-iconfield iconPosition="left">
              <p-inputicon>
                  <i class="pi pi-search"></i>
              </p-inputicon>
              <input pInputText class="ml-10 w-full" type="text" (input)="filter($event, dt2)" placeholder="Search keyword" />
          </p-iconfield>
          <p-button class="ml-auto" label="Clear" [outlined]="true" icon="pi pi-filter-slash" (click)="clear(dt2)" />
          </div>
      </ng-template>

        <!-- Table Header -->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th pResizableColumn pSortableColumn="customer_id.name">
              Customer
              <p-sortIcon field="customer_id.name" />
            </th>
            <th pResizableColumn pSortableColumn="plan.name">
              Plan
              <p-sortIcon field="plan.name" />
            </th>
            <th>Is Active</th>
            <th pResizableColumn pSortableColumn="status">
              Status
              <p-sortIcon field="status" />
            </th>
            <th pResizableColumn pSortableColumn="next_due">
              Next Due
              <p-sortIcon field="next_due" />
            </th>
            <th pResizableColumn style="text-align: right">Months</th>
            <th
              pResizableColumn
              pSortableColumn="amount"
              style="text-align: right">
              Amount
              <p-sortIcon field="amount" />
            </th>
            <th
              pResizableColumn
              pSortableColumn="actual_amount"
              style="text-align: right">
              Actual Amount
              <p-sortIcon field="actual_amount" />
            </th>
            <th></th>
          </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td>
              {{ rowData.customer_id?.name }}
            </td>
            <td>
              {{ rowData.plan?.name }}
            </td>
            <td>
              <span [ngClass]="rowData.is_active ? 'green' : 'red'">
                {{ rowData.is_active | boolToText }}
              </span>
            </td>
            <td>
              <span [ngClass]="rowData.status === 'active' ? 'green' : 'red'">
                {{ rowData.status }}
              </span>
            </td>
            <td>
              {{ rowData.next_due | date }}
            </td>
            <td style="text-align: right">
              {{ rowData.months_to_bill }}
            </td>
            <td style="text-align: right">
              {{ rowData.amount | currency : "USD" }}
            </td>
            <td style="text-align: right">
              {{ rowData.actual_amount | currency : "USD" }}
            </td>
            <td>
              <p-button
                (click)="menuClicked(rowData); menu.toggle($event)"
                icon="pi pi-ellipsis-v" />
            </td>
          </tr>
        </ng-template>
      </p-table>
      <p-menu appendTo="body" #menu [model]="row_items" [popup]="true" />
    </div>
  </block-ui>
</div>
<app-subscription-change-plan-modal
  (onData)="handleData($event)"
  [objectType]="objectType"
  [objectId]="objectId"
  [visible]="changePlanVisible"></app-subscription-change-plan-modal>
<app-subscription-change-price-modal
  (onData)="handleData($event)"
  [objectType]="objectType"
  [objectId]="objectId"
  [visible]="changePriceVisible"></app-subscription-change-price-modal>
